module.exports = __webpack_public_path__ + "static/media/SchoolsOverview.cd758850.png";